var map = {
	"./01_error_code.json": "INR5",
	"./02_timestamp.json": "gE9e",
	"./03_digital_rule.json": "v0HI",
	"./04_rate_limits.json": "x6dl",
	"./05_system_time.json": "i6gS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4b0F";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/swapV2/api/basic \.json$
// module id = 4b0F
// module chunks = 3